import { jsxs as d, jsx as e } from "react/jsx-runtime";
import { clsx as i } from "clsx";
import { cloneElement as n } from "react";
function b({
  loading: o,
  loadingAccessibleLabel: t,
  label: s,
  iconLeft: r,
  iconRight: a
}) {
  return /* @__PURE__ */ d(
    "div",
    {
      className: i("relative flex items-center justify-center", {
        "min-w-xlarge": o
      }),
      children: [
        o && /* @__PURE__ */ d("div", { className: "absolute flex gap-[6px]", children: [
          /* @__PURE__ */ e("span", { className: "sr-only", children: t }),
          /* @__PURE__ */ e(
            "div",
            {
              "data-testid": "loading-dot",
              className: "box-border size-xsmall rounded-full border-2 border-solid border-onSecondaryContainer bg-onSecondaryContainer opacity-medium motion-safe:animate-loading-dot1"
            }
          ),
          /* @__PURE__ */ e(
            "div",
            {
              "data-testid": "loading-dot",
              className: "box-border size-xsmall rounded-full border-2 border-solid border-onSecondaryContainer bg-onSecondaryContainer opacity-medium motion-safe:animate-loading-dot2"
            }
          ),
          /* @__PURE__ */ e(
            "div",
            {
              "data-testid": "loading-dot",
              className: "box-border size-xsmall rounded-full border-2 border-solid border-onSecondaryContainer bg-onSecondaryContainer opacity-medium motion-safe:animate-loading-dot3"
            }
          )
        ] }),
        /* @__PURE__ */ d(
          "div",
          {
            className: i("flex items-center justify-center gap-xsmall", {
              invisible: o
            }),
            children: [
              r && n(r, { size: "medium" }),
              /* @__PURE__ */ e("span", { children: s }),
              a && n(a, { size: "medium" })
            ]
          }
        )
      ]
    }
  );
}
export {
  b as ButtonBody
};
